import React, {useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from "./store";
import MainRouter from "./MainRouter";
import InitializeApp from "./components/InitializeApp";
import {SessionState} from "./session_state";
import ResponsiveAppBar from "./features/navigation/ResponsiveAppbar";
import {Box, Button, Container, Typography} from "@mui/material";
import ErrorList from "./features/errors/ErrorList";
import {AuthContext} from "./provider/AuthProvider";
import {BrowserRouter} from "react-router";
import AuthRouter from "./features/auth/AuthRouter";
import {init_session} from "./session_state/session_state_reducer";
import logo from "/assets/imgs/logo.png";
import "./index.scss"

import "./lang/i18n";


const App = () => {
    const {
        initialized,
        message,
    } = useSelector<RootState, SessionState>((state) => state.sessionState)
    const auth = useContext(AuthContext);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!auth.session?.user) {
            return;
        }
        dispatch(init_session(auth.session.user.id))
    }, [auth.user])

    if (auth.user === null) {
        return <InitializeApp/>;
    }


    if (auth.user === false) {
        return <BrowserRouter>
            <AuthRouter/>
        </BrowserRouter>
    }

    if (initialized) {
        return <BrowserRouter>
            <ResponsiveAppBar/>
            <Container
                maxWidth={false}
                sx={{
                    pl: {xs: "5px", md: "1em"},
                    pr: {xs: "5px", md: "1em"}
                }}>
                <MainRouter/>
            </Container>
            <ErrorList/>
        </BrowserRouter>
    }

    return <Box sx={{mt: "40vh", ml: "auto", mr: "auto", textAlign: "center"}}>
        <img alt="logo" width={65} src={logo}/>
        <Box>
            {!message && <Typography variant={"h4"}> Initializing app..</Typography>}
            {message && <Typography variant={"h4"} sx={{color: "error.main"}}> Error!</Typography>}
            {message && <Typography variant={"body1"} component={"p"}>{message}</Typography>}
            <Button variant={"contained"} sx={{mt: 3}} onClick={() => {
                window.location.reload();
            }}>Reload</Button>
        </Box>
    </Box>;
};

export default App;
